var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12H15.6L13.8 15H10.2L8.4 12H3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.105 5.97125L3 12V17.25C3 17.7141 3.18964 18.1592 3.52721 18.4874C3.86477 18.8156 4.32261 19 4.8 19H19.2C19.6774 19 20.1352 18.8156 20.4728 18.4874C20.8104 18.1592 21 17.7141 21 17.25V12L17.895 5.97125C17.746 5.67969 17.5163 5.43432 17.2317 5.26274C16.9471 5.09116 16.6189 5.00017 16.284 5H7.716C7.38112 5.00017 7.05294 5.09116 6.76834 5.26274C6.48374 5.43432 6.25402 5.67969 6.105 5.97125V5.97125Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgInbox;